import Attribute from '@/components/Attribute'
import Descriptor from '@/components/Descriptor'
import Effect from '@/components/Effect'
import Item from '@/components/Item'
import Resource from '@/components/Resource'
import Skill from '@/components/Skill'
import Spell from '@/components/Spell'
import Trait from '@/components/Trait'

export default {
  Attribute,
  Descriptor,
  Effect,
  Item,
  Resource,
  Skill,
  Spell,
  Trait,
}
